var _props, _props2, _props3, _props4, _props5, _props6, _props7, _props8, _props9, _props10, _props11, _props12, _props13, _props14, _props15, _props16;

import { IDENTIFIERS } from '../../../types/Identifiers';
import { TAG_TYPES } from '../../../types/TagTypes';
import PROPS from '../../../types/Props';
export var BLOG_POST = {
  tags: [{
    type: TAG_TYPES.TITLE,
    children: '{{blog-post.title}}'
  }, {
    type: TAG_TYPES.META,
    props: (_props = {}, _props[PROPS.NAME] = 'description', _props[PROPS.CONTENT] = "{{blog-post.description}}", _props)
  }, {
    type: TAG_TYPES.META,
    props: (_props2 = {}, _props2[PROPS.PROPERTY] = 'og:title', _props2[PROPS.CONTENT] = "{{@" + IDENTIFIERS.TITLE + "}}", _props2)
  }, {
    type: TAG_TYPES.META,
    props: (_props3 = {}, _props3[PROPS.PROPERTY] = 'og:description', _props3[PROPS.CONTENT] = "{{@" + IDENTIFIERS.DESCRIPTION + "}}", _props3)
  }, {
    type: TAG_TYPES.META,
    props: (_props4 = {}, _props4[PROPS.PROPERTY] = 'og:url', _props4[PROPS.CONTENT] = '{{blog-post.url}}', _props4)
  }, {
    type: TAG_TYPES.META,
    props: (_props5 = {}, _props5[PROPS.PROPERTY] = 'og:site_name', _props5[PROPS.CONTENT] = '{{site.name}}', _props5)
  }, {
    type: TAG_TYPES.META,
    props: (_props6 = {}, _props6[PROPS.PROPERTY] = 'og:type', _props6[PROPS.CONTENT] = 'article', _props6)
  }, {
    type: TAG_TYPES.META,
    props: (_props7 = {}, _props7[PROPS.PROPERTY] = 'og:image', _props7[PROPS.CONTENT] = '{{blog-post.cover.image}}', _props7)
  }, {
    type: TAG_TYPES.META,
    props: (_props8 = {}, _props8[PROPS.PROPERTY] = 'og:image:height', _props8[PROPS.CONTENT] = '{{blog-post.cover.image.height}}', _props8)
  }, {
    type: TAG_TYPES.META,
    props: (_props9 = {}, _props9[PROPS.PROPERTY] = 'og:image:width', _props9[PROPS.CONTENT] = '{{blog-post.cover.image.width}}', _props9)
  }, {
    type: TAG_TYPES.META,
    props: (_props10 = {}, _props10[PROPS.PROPERTY] = 'article:author', _props10[PROPS.CONTENT] = '{{blog-post.author}}', _props10)
  }, {
    type: TAG_TYPES.META,
    props: (_props11 = {}, _props11[PROPS.PROPERTY] = 'article:published_time', _props11[PROPS.CONTENT] = '{{blog-post.publish.date}}', _props11)
  }, {
    type: TAG_TYPES.META,
    props: (_props12 = {}, _props12[PROPS.PROPERTY] = 'article:modified_time', _props12[PROPS.CONTENT] = '{{blog-post.modified.date}}', _props12)
  }, {
    type: TAG_TYPES.LINK,
    props: (_props13 = {}, _props13[PROPS.REL] = 'amphtml', _props13[PROPS.HREF] = '{{blog-post.amp.url}}', _props13),
    disabled: '{{blog-post.disable-amp}}'
  }, {
    type: TAG_TYPES.LINK,
    props: (_props14 = {}, _props14[PROPS.REL] = 'canonical', _props14[PROPS.HREF] = '{{blog-post.url}}', _props14)
  }, {
    type: TAG_TYPES.META,
    props: (_props15 = {}, _props15[PROPS.NAME] = 'robots', _props15[PROPS.CONTENT] = '{{blog-post.index}}', _props15)
  }, {
    type: TAG_TYPES.SCRIPT,
    props: (_props16 = {}, _props16[PROPS.TYPE] = 'application/ld+json', _props16),
    disabled: '{{blog-post.disable-schema}}',
    children: "{\n        \"@context\": \"https://schema.org\",\n        \"@type\": \"BlogPosting\",\n        \"author\": {\n          \"@type\": \"Person\",\n          \"name\": \"{{blog-post.author}}\",\n          \"image\": {\n            \"@type\": \"ImageObject\",\n            \"height\": \"{{blog-post.author.image.height}}\",\n            \"width\": \"{{blog-post.author.image.width}}\",\n            \"url\": \"{{blog-post.author.image.url}}\"\n          }\n        },\n        \"articleSection\": \"{{blog-post.categories}}\",\n        \"dateModified\": \"{{blog-post.modified.date}}\",\n        \"datePublished\": \"{{blog-post.publish.date}}\",\n        \"headline\": \"{{blog-post.headline}}\",\n        \"mainEntityOfPage\": {\n          \"@id\": \"{{blog-post.url}}\",\n          \"@type\": \"itemPage\",\n          \"url\": \"{{blog-post.url}}\"\n        },\n        \"description\": \"{{blog-post.description}}\",\n        \"url\": \"{{blog-post.url}}\",\n        \"image\": {\n          \"@type\": \"ImageObject\",\n          \"height\": \"{{blog-post.cover.image.height}}\",\n          \"width\": \"{{blog-post.cover.image.width}}\",\n          \"url\": \"{{blog-post.cover.image}}\"\n        },\n        \"publisher\": {\n          \"@type\": \"Organization\",\n          \"name\": \"{{site.name}}\",\n          \"logo\": {\n            \"@type\": \"ImageObject\",\n            \"url\": \"{{site.business.logo}}\"\n          }\n        }\n      }"
  }]
};